export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1484071096222-7936a931e094?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxzb2NrcyUyMGZsYXRsYXklMjBtb25vY2hyb21lJTIwYmxhY2slMjB3aGl0ZSUyMGZvbGRlZCUyMHNvY2tzfGVufDB8fHx8MTc5MjI4OTk4Mnww&ixlib=rb-4.1.0&q=85";

export const PRODUCTS = [
  {
    id: "white-supreme-socks",
    name: "White Supreme Crew Socks",
    original_price: 25,
    deal_price: 19,
    badge: "BESTSELLER",
    discount: "SAVE $6 - 24% OFF",
    description:
      "Premium cotton-blend white crew socks with the signature red box aesthetic. Ribbed cuff, cushioned sole, all-day comfort.",
    stock_text: "IN STOCK: 3 packs of 4 pairs + 1 pack of 2 pairs",
    pack_options: [
      { label: "4-Pair Pack", pairs: 4, max: 3 },
      { label: "2-Pair Pack", pairs: 2, max: 1 },
    ],
    image:
      "https://images.unsplash.com/photo-1631180543602-727e1197619d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxmb2xkZWQlMjBzb2NrcyUyMHN0cmVldHdlYXIlMjBzb2NrcyUyMGVkaXRvcmlhbHxlbnwwfHx8fDE3OTIyODk5MTR8MA&ixlib=rb-4.1.0&q=85",
    card_testid: "product-card-white-socks",
    buy_testid: "buy-white-socks-btn",
  },
  {
    id: "black-supreme-socks",
    name: "Black Supreme Stealth Socks",
    original_price: 25,
    deal_price: 20,
    badge: "LIMITED 2-WEEK DEAL",
    discount: "SPECIAL DEAL - SAVE $5",
    description:
      "Deep black moisture-wicking athletic socks with a minimalist high-contrast weave. Extreme durability and street comfort.",
    stock_text: "IN STOCK: 4 packs - 4 pairs in every pack",
    pack_options: [{ label: "4-Pair Pack", pairs: 4, max: 4 }],
    image:
      "https://images.pexels.com/photos/5746084/pexels-photo-5746084.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    card_testid: "product-card-black-socks",
    buy_testid: "buy-black-socks-btn",
  },
];

export const PAYMENTS = [
  {
    id: "cashapp",
    name: "Cash App",
    tag: "$4TellThem",
    url: "https://cash.app/$4TellThem",
    note: "Send the exact total to $4TellThem and put your order email in the note.",
  },
  {
    id: "venmo",
    name: "Venmo",
    tag: "@Isaac-Brenna",
    url: "https://venmo.com/u/Isaac-Brenna",
    note: "Send the exact total to @Isaac-Brenna with your order email in the memo.",
  },
  {
    id: "paypal",
    name: "PayPal",
    tag: "paypal.me/4STarEX",
    url: "https://paypal.me/4STarEX",
    note: "Send the exact total via PayPal to paypal.me/4STarEX and put your order email in the note.",
  },
  {
    id: "stripe",
    name: "Card",
    tag: "VISA - Mastercard",
    note: "Pay securely by card right at checkout - instant confirmation, powered by Stripe.",
  },
];

export const MARQUEE_ITEMS = [
  "WHITE SUPREME SOCKS $19",
  "WAS $25",
  "BLACK SUPREME SOCKS $20",
  "2-WEEK DEAL ONLY",
  "BLACK: 4 PACKS OF 4 PAIRS",
  "WHITE: 4-PAIR + 2-PAIR PACKS",
  "CASH APP - VENMO - PAYPAL - CARD",
  "VERIFICATION CODE EMAILED INSTANTLY",
  "SHIPPING NOT INCLUDED",
];
